
import { defineComponent, SetupContext } from 'vue';
import Popup from 'vant/lib/popup';

const PwaSharePopup = defineComponent({
    components: {
        Popup,
    },

    props: {
        visible: Boolean,
        title: {
            type: String,
            default: () => '',
        },
        desc: {
            type: String,
            default: () => '',
        },
        okButtonText: {
            type: String,
            default: () => '',
        },
        cancelButtonText: {
            type: String,
            default: () => '',
        },
    },

    setup(_: unknown, ctx: SetupContext<Array<'onOk' | 'onCancel'>>) {
        const handleOk = () => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('onOk');
        };

        const handleCancel = () => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('onCancel');
        };

        return {
            handleOk,
            handleCancel,
        };
    },
});

export default PwaSharePopup;
